import Reflux from 'reflux';

const AlertNotificationsActions = Reflux.createActions({
  available: { asyncResult: true },
  listAll: { asyncResult: true },
  testAlert: { asyncResult: true },
});

export default AlertNotificationsActions;



// WEBPACK FOOTER //
// /var/lib/jenkins/workspace/graylog-project-cli-release/.repos/graylog2-server/graylog2-web-interface/src/actions/alertnotifications/AlertNotificationsActions.jsx